
import React, { Fragment } from "react";

import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

import { bankAccountsService } from 'Services';
import TableRowDelete from 'CommonElements/Table/TableRowDelete';


const EditBankAccount = ({ data={}, loadData }) => {


  const deleteBankAccount = () => {
    SweetAlert.fire({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to recover this record!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true,
    }).then((result) => {
        if (result.value) {
            bankAccountsService.deleteBankAccount(data.id).then(res => {
                toast.success('Bank account delete, successfully');
                loadData();
            }).catch(err => {
                toast.error('Failed to delete Bank Account');

            })
        }
    });
};
  return (
    <Fragment>
        <TableRowDelete onClick={deleteBankAccount} />

    </Fragment>
  );
};

export default EditBankAccount;
